import React from "react";
import useDraggableBase from "./base.js";
const useDraggable = _ref => {
  let {
    navigation
  } = _ref;
  const onDrag = React.useCallback(_ref2 => {
    let {
      distance,
      target
    } = _ref2;
    const relativeDistance = distance / target.clientWidth;
    navigation.drag(relativeDistance);
  }, [navigation]);
  return useDraggableBase({
    onDrag,
    onDragEnd: navigation.adjust
  });
};
export default useDraggable;